@theme {
  --color-nsw-grey-50: var(--nsw-grey-50);
  --color-nsw-grey-100: var(--nsw-grey-100);
  --color-nsw-grey-150: var(--nsw-grey-150);
  --color-nsw-grey-200: var(--nsw-grey-200);
  --color-nsw-grey-250: var(--nsw-grey-250);
  --color-nsw-grey-300: var(--nsw-grey-300);
  --color-nsw-grey-350: var(--nsw-grey-350);
  --color-nsw-grey-400: var(--nsw-grey-400);
  --color-nsw-grey-450: var(--nsw-grey-450);
  --color-nsw-grey-500: var(--nsw-grey-500);
  --color-nsw-grey-550: var(--nsw-grey-550);
  --color-nsw-grey-600: var(--nsw-grey-600);
  --color-nsw-grey-650: var(--nsw-grey-650);
  --color-nsw-grey-700: var(--nsw-grey-700);
  --color-nsw-grey-750: var(--nsw-grey-750);
  --color-nsw-grey-800: var(--nsw-grey-800);
  --color-nsw-grey-850: var(--nsw-grey-850);
  --color-nsw-grey-900: var(--nsw-grey-900);
  --color-nsw-grey-950: var(--nsw-grey-950);
  --color-nsw-green-50: var(--nsw-green-50);
  --color-nsw-green-100: var(--nsw-green-100);
  --color-nsw-green-150: var(--nsw-green-150);
  --color-nsw-green-200: var(--nsw-green-200);
  --color-nsw-green-250: var(--nsw-green-250);
  --color-nsw-green-300: var(--nsw-green-300);
  --color-nsw-green-350: var(--nsw-green-350);
  --color-nsw-green-400: var(--nsw-green-400);
  --color-nsw-green-450: var(--nsw-green-450);
  --color-nsw-green-500: var(--nsw-green-500);
  --color-nsw-green-550: var(--nsw-green-550);
  --color-nsw-green-600: var(--nsw-green-600);
  --color-nsw-green-650: var(--nsw-green-650);
  --color-nsw-green-700: var(--nsw-green-700);
  --color-nsw-green-750: var(--nsw-green-750);
  --color-nsw-green-800: var(--nsw-green-800);
  --color-nsw-green-850: var(--nsw-green-850);
  --color-nsw-green-900: var(--nsw-green-900);
  --color-nsw-green-950: var(--nsw-green-950);
  --color-nsw-teal-50: var(--nsw-teal-50);
  --color-nsw-teal-100: var(--nsw-teal-100);
  --color-nsw-teal-150: var(--nsw-teal-150);
  --color-nsw-teal-200: var(--nsw-teal-200);
  --color-nsw-teal-250: var(--nsw-teal-250);
  --color-nsw-teal-300: var(--nsw-teal-300);
  --color-nsw-teal-350: var(--nsw-teal-350);
  --color-nsw-teal-400: var(--nsw-teal-400);
  --color-nsw-teal-450: var(--nsw-teal-450);
  --color-nsw-teal-500: var(--nsw-teal-500);
  --color-nsw-teal-550: var(--nsw-teal-550);
  --color-nsw-teal-600: var(--nsw-teal-600);
  --color-nsw-teal-650: var(--nsw-teal-650);
  --color-nsw-teal-700: var(--nsw-teal-700);
  --color-nsw-teal-750: var(--nsw-teal-750);
  --color-nsw-teal-800: var(--nsw-teal-800);
  --color-nsw-teal-850: var(--nsw-teal-850);
  --color-nsw-teal-900: var(--nsw-teal-900);
  --color-nsw-teal-950: var(--nsw-teal-950);
  --color-nsw-blue-50: var(--nsw-blue-50);
  --color-nsw-blue-100: var(--nsw-blue-100);
  --color-nsw-blue-150: var(--nsw-blue-150);
  --color-nsw-blue-200: var(--nsw-blue-200);
  --color-nsw-blue-250: var(--nsw-blue-250);
  --color-nsw-blue-300: var(--nsw-blue-300);
  --color-nsw-blue-350: var(--nsw-blue-350);
  --color-nsw-blue-400: var(--nsw-blue-400);
  --color-nsw-blue-450: var(--nsw-blue-450);
  --color-nsw-blue-500: var(--nsw-blue-500);
  --color-nsw-blue-550: var(--nsw-blue-550);
  --color-nsw-blue-600: var(--nsw-blue-600);
  --color-nsw-blue-650: var(--nsw-blue-650);
  --color-nsw-blue-700: var(--nsw-blue-700);
  --color-nsw-blue-750: var(--nsw-blue-750);
  --color-nsw-blue-800: var(--nsw-blue-800);
  --color-nsw-blue-850: var(--nsw-blue-850);
  --color-nsw-blue-900: var(--nsw-blue-900);
  --color-nsw-blue-950: var(--nsw-blue-950);
  --color-nsw-purple-50: var(--nsw-purple-50);
  --color-nsw-purple-100: var(--nsw-purple-100);
  --color-nsw-purple-150: var(--nsw-purple-150);
  --color-nsw-purple-200: var(--nsw-purple-200);
  --color-nsw-purple-250: var(--nsw-purple-250);
  --color-nsw-purple-300: var(--nsw-purple-300);
  --color-nsw-purple-350: var(--nsw-purple-350);
  --color-nsw-purple-400: var(--nsw-purple-400);
  --color-nsw-purple-450: var(--nsw-purple-450);
  --color-nsw-purple-500: var(--nsw-purple-500);
  --color-nsw-purple-550: var(--nsw-purple-550);
  --color-nsw-purple-600: var(--nsw-purple-600);
  --color-nsw-purple-650: var(--nsw-purple-650);
  --color-nsw-purple-700: var(--nsw-purple-700);
  --color-nsw-purple-750: var(--nsw-purple-750);
  --color-nsw-purple-800: var(--nsw-purple-800);
  --color-nsw-purple-850: var(--nsw-purple-850);
  --color-nsw-purple-900: var(--nsw-purple-900);
  --color-nsw-purple-950: var(--nsw-purple-950);
  --color-nsw-fuchsia-50: var(--nsw-fuchsia-50);
  --color-nsw-fuchsia-100: var(--nsw-fuchsia-100);
  --color-nsw-fuchsia-150: var(--nsw-fuchsia-150);
  --color-nsw-fuchsia-200: var(--nsw-fuchsia-200);
  --color-nsw-fuchsia-250: var(--nsw-fuchsia-250);
  --color-nsw-fuchsia-300: var(--nsw-fuchsia-300);
  --color-nsw-fuchsia-350: var(--nsw-fuchsia-350);
  --color-nsw-fuchsia-400: var(--nsw-fuchsia-400);
  --color-nsw-fuchsia-450: var(--nsw-fuchsia-450);
  --color-nsw-fuchsia-500: var(--nsw-fuchsia-500);
  --color-nsw-fuchsia-550: var(--nsw-fuchsia-550);
  --color-nsw-fuchsia-600: var(--nsw-fuchsia-600);
  --color-nsw-fuchsia-650: var(--nsw-fuchsia-650);
  --color-nsw-fuchsia-700: var(--nsw-fuchsia-700);
  --color-nsw-fuchsia-750: var(--nsw-fuchsia-750);
  --color-nsw-fuchsia-800: var(--nsw-fuchsia-800);
  --color-nsw-fuchsia-850: var(--nsw-fuchsia-850);
  --color-nsw-fuchsia-900: var(--nsw-fuchsia-900);
  --color-nsw-fuchsia-950: var(--nsw-fuchsia-950);
  --color-nsw-red-50: var(--nsw-red-50);
  --color-nsw-red-100: var(--nsw-red-100);
  --color-nsw-red-150: var(--nsw-red-150);
  --color-nsw-red-200: var(--nsw-red-200);
  --color-nsw-red-250: var(--nsw-red-250);
  --color-nsw-red-300: var(--nsw-red-300);
  --color-nsw-red-350: var(--nsw-red-350);
  --color-nsw-red-400: var(--nsw-red-400);
  --color-nsw-red-450: var(--nsw-red-450);
  --color-nsw-red-500: var(--nsw-red-500);
  --color-nsw-red-550: var(--nsw-red-550);
  --color-nsw-red-600: var(--nsw-red-600);
  --color-nsw-red-650: var(--nsw-red-650);
  --color-nsw-red-700: var(--nsw-red-700);
  --color-nsw-red-750: var(--nsw-red-750);
  --color-nsw-red-800: var(--nsw-red-800);
  --color-nsw-red-850: var(--nsw-red-850);
  --color-nsw-red-900: var(--nsw-red-900);
  --color-nsw-red-950: var(--nsw-red-950);
  --color-nsw-orange-50: var(--nsw-orange-50);
  --color-nsw-orange-100: var(--nsw-orange-100);
  --color-nsw-orange-150: var(--nsw-orange-150);
  --color-nsw-orange-200: var(--nsw-orange-200);
  --color-nsw-orange-250: var(--nsw-orange-250);
  --color-nsw-orange-300: var(--nsw-orange-300);
  --color-nsw-orange-350: var(--nsw-orange-350);
  --color-nsw-orange-400: var(--nsw-orange-400);
  --color-nsw-orange-450: var(--nsw-orange-450);
  --color-nsw-orange-500: var(--nsw-orange-500);
  --color-nsw-orange-550: var(--nsw-orange-550);
  --color-nsw-orange-600: var(--nsw-orange-600);
  --color-nsw-orange-650: var(--nsw-orange-650);
  --color-nsw-orange-700: var(--nsw-orange-700);
  --color-nsw-orange-750: var(--nsw-orange-750);
  --color-nsw-orange-800: var(--nsw-orange-800);
  --color-nsw-orange-850: var(--nsw-orange-850);
  --color-nsw-orange-900: var(--nsw-orange-900);
  --color-nsw-orange-950: var(--nsw-orange-950);
  --color-nsw-yellow-50: var(--nsw-yellow-50);
  --color-nsw-yellow-100: var(--nsw-yellow-100);
  --color-nsw-yellow-150: var(--nsw-yellow-150);
  --color-nsw-yellow-200: var(--nsw-yellow-200);
  --color-nsw-yellow-250: var(--nsw-yellow-250);
  --color-nsw-yellow-300: var(--nsw-yellow-300);
  --color-nsw-yellow-350: var(--nsw-yellow-350);
  --color-nsw-yellow-400: var(--nsw-yellow-400);
  --color-nsw-yellow-450: var(--nsw-yellow-450);
  --color-nsw-yellow-500: var(--nsw-yellow-500);
  --color-nsw-yellow-550: var(--nsw-yellow-550);
  --color-nsw-yellow-600: var(--nsw-yellow-600);
  --color-nsw-yellow-650: var(--nsw-yellow-650);
  --color-nsw-yellow-700: var(--nsw-yellow-700);
  --color-nsw-yellow-750: var(--nsw-yellow-750);
  --color-nsw-yellow-800: var(--nsw-yellow-800);
  --color-nsw-yellow-850: var(--nsw-yellow-850);
  --color-nsw-yellow-900: var(--nsw-yellow-900);
  --color-nsw-yellow-950: var(--nsw-yellow-950);
  --color-nsw-brown-50: var(--nsw-brown-50);
  --color-nsw-brown-100: var(--nsw-brown-100);
  --color-nsw-brown-150: var(--nsw-brown-150);
  --color-nsw-brown-200: var(--nsw-brown-200);
  --color-nsw-brown-250: var(--nsw-brown-250);
  --color-nsw-brown-300: var(--nsw-brown-300);
  --color-nsw-brown-350: var(--nsw-brown-350);
  --color-nsw-brown-400: var(--nsw-brown-400);
  --color-nsw-brown-450: var(--nsw-brown-450);
  --color-nsw-brown-500: var(--nsw-brown-500);
  --color-nsw-brown-550: var(--nsw-brown-550);
  --color-nsw-brown-600: var(--nsw-brown-600);
  --color-nsw-brown-650: var(--nsw-brown-650);
  --color-nsw-brown-700: var(--nsw-brown-700);
  --color-nsw-brown-750: var(--nsw-brown-750);
  --color-nsw-brown-800: var(--nsw-brown-800);
  --color-nsw-brown-850: var(--nsw-brown-850);
  --color-nsw-brown-900: var(--nsw-brown-900);
  --color-nsw-brown-950: var(--nsw-brown-950);
  --color-nsw-aboriginal-grey-50: var(--nsw-aboriginal-grey-50);
  --color-nsw-aboriginal-grey-100: var(--nsw-aboriginal-grey-100);
  --color-nsw-aboriginal-grey-150: var(--nsw-aboriginal-grey-150);
  --color-nsw-aboriginal-grey-200: var(--nsw-aboriginal-grey-200);
  --color-nsw-aboriginal-grey-250: var(--nsw-aboriginal-grey-250);
  --color-nsw-aboriginal-grey-300: var(--nsw-aboriginal-grey-300);
  --color-nsw-aboriginal-grey-350: var(--nsw-aboriginal-grey-350);
  --color-nsw-aboriginal-grey-400: var(--nsw-aboriginal-grey-400);
  --color-nsw-aboriginal-grey-450: var(--nsw-aboriginal-grey-450);
  --color-nsw-aboriginal-grey-500: var(--nsw-aboriginal-grey-500);
  --color-nsw-aboriginal-grey-550: var(--nsw-aboriginal-grey-550);
  --color-nsw-aboriginal-grey-600: var(--nsw-aboriginal-grey-600);
  --color-nsw-aboriginal-grey-650: var(--nsw-aboriginal-grey-650);
  --color-nsw-aboriginal-grey-700: var(--nsw-aboriginal-grey-700);
  --color-nsw-aboriginal-grey-750: var(--nsw-aboriginal-grey-750);
  --color-nsw-aboriginal-grey-800: var(--nsw-aboriginal-grey-800);
  --color-nsw-aboriginal-grey-850: var(--nsw-aboriginal-grey-850);
  --color-nsw-aboriginal-grey-900: var(--nsw-aboriginal-grey-900);
  --color-nsw-aboriginal-grey-950: var(--nsw-aboriginal-grey-950);
  --color-nsw-aboriginal-red-50: var(--nsw-aboriginal-red-50);
  --color-nsw-aboriginal-red-100: var(--nsw-aboriginal-red-100);
  --color-nsw-aboriginal-red-150: var(--nsw-aboriginal-red-150);
  --color-nsw-aboriginal-red-200: var(--nsw-aboriginal-red-200);
  --color-nsw-aboriginal-red-250: var(--nsw-aboriginal-red-250);
  --color-nsw-aboriginal-red-300: var(--nsw-aboriginal-red-300);
  --color-nsw-aboriginal-red-350: var(--nsw-aboriginal-red-350);
  --color-nsw-aboriginal-red-400: var(--nsw-aboriginal-red-400);
  --color-nsw-aboriginal-red-450: var(--nsw-aboriginal-red-450);
  --color-nsw-aboriginal-red-500: var(--nsw-aboriginal-red-500);
  --color-nsw-aboriginal-red-550: var(--nsw-aboriginal-red-550);
  --color-nsw-aboriginal-red-600: var(--nsw-aboriginal-red-600);
  --color-nsw-aboriginal-red-650: var(--nsw-aboriginal-red-650);
  --color-nsw-aboriginal-red-700: var(--nsw-aboriginal-red-700);
  --color-nsw-aboriginal-red-750: var(--nsw-aboriginal-red-750);
  --color-nsw-aboriginal-red-800: var(--nsw-aboriginal-red-800);
  --color-nsw-aboriginal-red-850: var(--nsw-aboriginal-red-850);
  --color-nsw-aboriginal-red-900: var(--nsw-aboriginal-red-900);
  --color-nsw-aboriginal-red-950: var(--nsw-aboriginal-red-950);
  --color-nsw-aboriginal-orange-50: var(--nsw-aboriginal-orange-50);
  --color-nsw-aboriginal-orange-100: var(--nsw-aboriginal-orange-100);
  --color-nsw-aboriginal-orange-150: var(--nsw-aboriginal-orange-150);
  --color-nsw-aboriginal-orange-200: var(--nsw-aboriginal-orange-200);
  --color-nsw-aboriginal-orange-250: var(--nsw-aboriginal-orange-250);
  --color-nsw-aboriginal-orange-300: var(--nsw-aboriginal-orange-300);
  --color-nsw-aboriginal-orange-350: var(--nsw-aboriginal-orange-350);
  --color-nsw-aboriginal-orange-400: var(--nsw-aboriginal-orange-400);
  --color-nsw-aboriginal-orange-450: var(--nsw-aboriginal-orange-450);
  --color-nsw-aboriginal-orange-500: var(--nsw-aboriginal-orange-500);
  --color-nsw-aboriginal-orange-550: var(--nsw-aboriginal-orange-550);
  --color-nsw-aboriginal-orange-600: var(--nsw-aboriginal-orange-600);
  --color-nsw-aboriginal-orange-650: var(--nsw-aboriginal-orange-650);
  --color-nsw-aboriginal-orange-700: var(--nsw-aboriginal-orange-700);
  --color-nsw-aboriginal-orange-750: var(--nsw-aboriginal-orange-750);
  --color-nsw-aboriginal-orange-800: var(--nsw-aboriginal-orange-800);
  --color-nsw-aboriginal-orange-850: var(--nsw-aboriginal-orange-850);
  --color-nsw-aboriginal-orange-900: var(--nsw-aboriginal-orange-900);
  --color-nsw-aboriginal-orange-950: var(--nsw-aboriginal-orange-950);
  --color-nsw-aboriginal-brown-50: var(--nsw-aboriginal-brown-50);
  --color-nsw-aboriginal-brown-100: var(--nsw-aboriginal-brown-100);
  --color-nsw-aboriginal-brown-150: var(--nsw-aboriginal-brown-150);
  --color-nsw-aboriginal-brown-200: var(--nsw-aboriginal-brown-200);
  --color-nsw-aboriginal-brown-250: var(--nsw-aboriginal-brown-250);
  --color-nsw-aboriginal-brown-300: var(--nsw-aboriginal-brown-300);
  --color-nsw-aboriginal-brown-350: var(--nsw-aboriginal-brown-350);
  --color-nsw-aboriginal-brown-400: var(--nsw-aboriginal-brown-400);
  --color-nsw-aboriginal-brown-450: var(--nsw-aboriginal-brown-450);
  --color-nsw-aboriginal-brown-500: var(--nsw-aboriginal-brown-500);
  --color-nsw-aboriginal-brown-550: var(--nsw-aboriginal-brown-550);
  --color-nsw-aboriginal-brown-600: var(--nsw-aboriginal-brown-600);
  --color-nsw-aboriginal-brown-650: var(--nsw-aboriginal-brown-650);
  --color-nsw-aboriginal-brown-700: var(--nsw-aboriginal-brown-700);
  --color-nsw-aboriginal-brown-750: var(--nsw-aboriginal-brown-750);
  --color-nsw-aboriginal-brown-800: var(--nsw-aboriginal-brown-800);
  --color-nsw-aboriginal-brown-850: var(--nsw-aboriginal-brown-850);
  --color-nsw-aboriginal-brown-900: var(--nsw-aboriginal-brown-900);
  --color-nsw-aboriginal-brown-950: var(--nsw-aboriginal-brown-950);
  --color-nsw-aboriginal-yellow-50: var(--nsw-aboriginal-yellow-50);
  --color-nsw-aboriginal-yellow-100: var(--nsw-aboriginal-yellow-100);
  --color-nsw-aboriginal-yellow-150: var(--nsw-aboriginal-yellow-150);
  --color-nsw-aboriginal-yellow-200: var(--nsw-aboriginal-yellow-200);
  --color-nsw-aboriginal-yellow-250: var(--nsw-aboriginal-yellow-250);
  --color-nsw-aboriginal-yellow-300: var(--nsw-aboriginal-yellow-300);
  --color-nsw-aboriginal-yellow-350: var(--nsw-aboriginal-yellow-350);
  --color-nsw-aboriginal-yellow-400: var(--nsw-aboriginal-yellow-400);
  --color-nsw-aboriginal-yellow-450: var(--nsw-aboriginal-yellow-450);
  --color-nsw-aboriginal-yellow-500: var(--nsw-aboriginal-yellow-500);
  --color-nsw-aboriginal-yellow-550: var(--nsw-aboriginal-yellow-550);
  --color-nsw-aboriginal-yellow-600: var(--nsw-aboriginal-yellow-600);
  --color-nsw-aboriginal-yellow-650: var(--nsw-aboriginal-yellow-650);
  --color-nsw-aboriginal-yellow-700: var(--nsw-aboriginal-yellow-700);
  --color-nsw-aboriginal-yellow-750: var(--nsw-aboriginal-yellow-750);
  --color-nsw-aboriginal-yellow-800: var(--nsw-aboriginal-yellow-800);
  --color-nsw-aboriginal-yellow-850: var(--nsw-aboriginal-yellow-850);
  --color-nsw-aboriginal-yellow-900: var(--nsw-aboriginal-yellow-900);
  --color-nsw-aboriginal-yellow-950: var(--nsw-aboriginal-yellow-950);
  --color-nsw-aboriginal-green-50: var(--nsw-aboriginal-green-50);
  --color-nsw-aboriginal-green-100: var(--nsw-aboriginal-green-100);
  --color-nsw-aboriginal-green-150: var(--nsw-aboriginal-green-150);
  --color-nsw-aboriginal-green-200: var(--nsw-aboriginal-green-200);
  --color-nsw-aboriginal-green-250: var(--nsw-aboriginal-green-250);
  --color-nsw-aboriginal-green-300: var(--nsw-aboriginal-green-300);
  --color-nsw-aboriginal-green-350: var(--nsw-aboriginal-green-350);
  --color-nsw-aboriginal-green-400: var(--nsw-aboriginal-green-400);
  --color-nsw-aboriginal-green-450: var(--nsw-aboriginal-green-450);
  --color-nsw-aboriginal-green-500: var(--nsw-aboriginal-green-500);
  --color-nsw-aboriginal-green-550: var(--nsw-aboriginal-green-550);
  --color-nsw-aboriginal-green-600: var(--nsw-aboriginal-green-600);
  --color-nsw-aboriginal-green-650: var(--nsw-aboriginal-green-650);
  --color-nsw-aboriginal-green-700: var(--nsw-aboriginal-green-700);
  --color-nsw-aboriginal-green-750: var(--nsw-aboriginal-green-750);
  --color-nsw-aboriginal-green-800: var(--nsw-aboriginal-green-800);
  --color-nsw-aboriginal-green-850: var(--nsw-aboriginal-green-850);
  --color-nsw-aboriginal-green-900: var(--nsw-aboriginal-green-900);
  --color-nsw-aboriginal-green-950: var(--nsw-aboriginal-green-950);
  --color-nsw-aboriginal-blue-50: var(--nsw-aboriginal-blue-50);
  --color-nsw-aboriginal-blue-100: var(--nsw-aboriginal-blue-100);
  --color-nsw-aboriginal-blue-150: var(--nsw-aboriginal-blue-150);
  --color-nsw-aboriginal-blue-200: var(--nsw-aboriginal-blue-200);
  --color-nsw-aboriginal-blue-250: var(--nsw-aboriginal-blue-250);
  --color-nsw-aboriginal-blue-300: var(--nsw-aboriginal-blue-300);
  --color-nsw-aboriginal-blue-350: var(--nsw-aboriginal-blue-350);
  --color-nsw-aboriginal-blue-400: var(--nsw-aboriginal-blue-400);
  --color-nsw-aboriginal-blue-450: var(--nsw-aboriginal-blue-450);
  --color-nsw-aboriginal-blue-500: var(--nsw-aboriginal-blue-500);
  --color-nsw-aboriginal-blue-550: var(--nsw-aboriginal-blue-550);
  --color-nsw-aboriginal-blue-600: var(--nsw-aboriginal-blue-600);
  --color-nsw-aboriginal-blue-650: var(--nsw-aboriginal-blue-650);
  --color-nsw-aboriginal-blue-700: var(--nsw-aboriginal-blue-700);
  --color-nsw-aboriginal-blue-750: var(--nsw-aboriginal-blue-750);
  --color-nsw-aboriginal-blue-800: var(--nsw-aboriginal-blue-800);
  --color-nsw-aboriginal-blue-850: var(--nsw-aboriginal-blue-850);
  --color-nsw-aboriginal-blue-900: var(--nsw-aboriginal-blue-900);
  --color-nsw-aboriginal-blue-950: var(--nsw-aboriginal-blue-950);
  --color-nsw-aboriginal-purple-50: var(--nsw-aboriginal-purple-50);
  --color-nsw-aboriginal-purple-100: var(--nsw-aboriginal-purple-100);
  --color-nsw-aboriginal-purple-150: var(--nsw-aboriginal-purple-150);
  --color-nsw-aboriginal-purple-200: var(--nsw-aboriginal-purple-200);
  --color-nsw-aboriginal-purple-250: var(--nsw-aboriginal-purple-250);
  --color-nsw-aboriginal-purple-300: var(--nsw-aboriginal-purple-300);
  --color-nsw-aboriginal-purple-350: var(--nsw-aboriginal-purple-350);
  --color-nsw-aboriginal-purple-400: var(--nsw-aboriginal-purple-400);
  --color-nsw-aboriginal-purple-450: var(--nsw-aboriginal-purple-450);
  --color-nsw-aboriginal-purple-500: var(--nsw-aboriginal-purple-500);
  --color-nsw-aboriginal-purple-550: var(--nsw-aboriginal-purple-550);
  --color-nsw-aboriginal-purple-600: var(--nsw-aboriginal-purple-600);
  --color-nsw-aboriginal-purple-650: var(--nsw-aboriginal-purple-650);
  --color-nsw-aboriginal-purple-700: var(--nsw-aboriginal-purple-700);
  --color-nsw-aboriginal-purple-750: var(--nsw-aboriginal-purple-750);
  --color-nsw-aboriginal-purple-800: var(--nsw-aboriginal-purple-800);
  --color-nsw-aboriginal-purple-850: var(--nsw-aboriginal-purple-850);
  --color-nsw-aboriginal-purple-900: var(--nsw-aboriginal-purple-900);
  --color-nsw-aboriginal-purple-950: var(--nsw-aboriginal-purple-950);
  --color-success-50: var(--success-50);
  --color-success-100: var(--success-100);
  --color-success-150: var(--success-150);
  --color-success-200: var(--success-200);
  --color-success-250: var(--success-250);
  --color-success-300: var(--success-300);
  --color-success-350: var(--success-350);
  --color-success-400: var(--success-400);
  --color-success-450: var(--success-450);
  --color-success-500: var(--success-500);
  --color-success-550: var(--success-550);
  --color-success-600: var(--success-600);
  --color-success-650: var(--success-650);
  --color-success-700: var(--success-700);
  --color-success-750: var(--success-750);
  --color-success-800: var(--success-800);
  --color-success-850: var(--success-850);
  --color-success-900: var(--success-900);
  --color-success-950: var(--success-950);
  --color-warning-50: var(--warning-50);
  --color-warning-100: var(--warning-100);
  --color-warning-150: var(--warning-150);
  --color-warning-200: var(--warning-200);
  --color-warning-250: var(--warning-250);
  --color-warning-300: var(--warning-300);
  --color-warning-350: var(--warning-350);
  --color-warning-400: var(--warning-400);
  --color-warning-450: var(--warning-450);
  --color-warning-500: var(--warning-500);
  --color-warning-550: var(--warning-550);
  --color-warning-600: var(--warning-600);
  --color-warning-650: var(--warning-650);
  --color-warning-700: var(--warning-700);
  --color-warning-750: var(--warning-750);
  --color-warning-800: var(--warning-800);
  --color-warning-850: var(--warning-850);
  --color-warning-900: var(--warning-900);
  --color-warning-950: var(--warning-950);
  --color-danger-50: var(--danger-50);
  --color-danger-100: var(--danger-100);
  --color-danger-150: var(--danger-150);
  --color-danger-200: var(--danger-200);
  --color-danger-250: var(--danger-250);
  --color-danger-300: var(--danger-300);
  --color-danger-350: var(--danger-350);
  --color-danger-400: var(--danger-400);
  --color-danger-450: var(--danger-450);
  --color-danger-500: var(--danger-500);
  --color-danger-550: var(--danger-550);
  --color-danger-600: var(--danger-600);
  --color-danger-650: var(--danger-650);
  --color-danger-700: var(--danger-700);
  --color-danger-750: var(--danger-750);
  --color-danger-800: var(--danger-800);
  --color-danger-850: var(--danger-850);
  --color-danger-900: var(--danger-900);
  --color-danger-950: var(--danger-950);
  --color-info-50: var(--info-50);
  --color-info-100: var(--info-100);
  --color-info-150: var(--info-150);
  --color-info-200: var(--info-200);
  --color-info-250: var(--info-250);
  --color-info-300: var(--info-300);
  --color-info-350: var(--info-350);
  --color-info-400: var(--info-400);
  --color-info-450: var(--info-450);
  --color-info-500: var(--info-500);
  --color-info-550: var(--info-550);
  --color-info-600: var(--info-600);
  --color-info-650: var(--info-650);
  --color-info-700: var(--info-700);
  --color-info-750: var(--info-750);
  --color-info-800: var(--info-800);
  --color-info-850: var(--info-850);
  --color-info-900: var(--info-900);
  --color-info-950: var(--info-950);
  --color-white: var(--white);
  --color-black: var(--black);
}

:root {
  --nsw-grey-50: rgb(250, 250, 250);
  --nsw-grey-100: rgb(245, 245, 245);
  --nsw-grey-150: rgb(240, 240, 240);
  --nsw-grey-200: rgb(235, 235, 235);
  --nsw-grey-250: rgb(227, 229, 230);
  --nsw-grey-300: rgb(220, 223, 224);
  --nsw-grey-350: rgb(212, 217, 219);
  --nsw-grey-400: rgb(205, 211, 214);
  --nsw-grey-450: rgb(170, 176, 180);
  --nsw-grey-500: rgb(136, 143, 146);
  --nsw-grey-550: rgb(104, 111, 114);
  --nsw-grey-600: rgb(73, 80, 84);
  --nsw-grey-650: rgb(63, 69, 73);
  --nsw-grey-700: rgb(53, 59, 63);
  --nsw-grey-750: rgb(43, 49, 53);
  --nsw-grey-800: rgb(34, 39, 43);
  --nsw-grey-850: rgb(24, 28, 31);
  --nsw-grey-900: rgb(14, 17, 19);
  --nsw-grey-950: rgb(5, 7, 9);
  --nsw-green-50: rgb(245, 255, 246);
  --nsw-green-100: rgb(236, 253, 238);
  --nsw-green-150: rgb(228, 252, 231);
  --nsw-green-200: rgb(219, 250, 223);
  --nsw-green-250: rgb(207, 247, 212);
  --nsw-green-300: rgb(194, 244, 201);
  --nsw-green-350: rgb(181, 240, 190);
  --nsw-green-400: rgb(168, 237, 179);
  --nsw-green-450: rgb(138, 220, 152);
  --nsw-green-500: rgb(106, 204, 125);
  --nsw-green-550: rgb(69, 187, 98);
  --nsw-green-600: rgb(0, 170, 69);
  --nsw-green-650: rgb(7, 142, 50);
  --nsw-green-700: rgb(7, 115, 32);
  --nsw-green-750: rgb(3, 89, 15);
  --nsw-green-800: rgb(0, 64, 0);
  --nsw-green-850: rgb(0, 48, 0);
  --nsw-green-900: rgb(0, 32, 0);
  --nsw-green-950: rgb(0, 17, 0);
  --nsw-teal-50: rgb(242, 251, 250);
  --nsw-teal-100: rgb(231, 247, 245);
  --nsw-teal-150: rgb(220, 242, 239);
  --nsw-teal-200: rgb(209, 238, 234);
  --nsw-teal-250: rgb(193, 234, 231);
  --nsw-teal-300: rgb(175, 229, 229);
  --nsw-teal-350: rgb(158, 224, 229);
  --nsw-teal-400: rgb(140, 219, 229);
  --nsw-teal-450: rgb(117, 196, 207);
  --nsw-teal-500: rgb(94, 172, 185);
  --nsw-teal-550: rgb(70, 150, 163);
  --nsw-teal-600: rgb(46, 128, 142);
  --nsw-teal-650: rgb(37, 111, 123);
  --nsw-teal-700: rgb(28, 95, 105);
  --nsw-teal-750: rgb(20, 78, 88);
  --nsw-teal-800: rgb(11, 63, 71);
  --nsw-teal-850: rgb(4, 47, 53);
  --nsw-teal-900: rgb(1, 31, 36);
  --nsw-teal-950: rgb(0, 17, 20);
  --nsw-blue-50: rgb(240, 251, 255);
  --nsw-blue-100: rgb(228, 246, 255);
  --nsw-blue-150: rgb(215, 242, 254);
  --nsw-blue-200: rgb(203, 237, 253);
  --nsw-blue-250: rgb(188, 234, 254);
  --nsw-blue-300: rgb(173, 231, 255);
  --nsw-blue-350: rgb(157, 227, 255);
  --nsw-blue-400: rgb(140, 224, 255);
  --nsw-blue-450: rgb(90, 201, 255);
  --nsw-blue-500: rgb(38, 174, 255);
  --nsw-blue-550: rgb(0, 143, 255);
  --nsw-blue-600: rgb(20, 108, 253);
  --nsw-blue-650: rgb(12, 90, 212);
  --nsw-blue-700: rgb(5, 72, 173);
  --nsw-blue-750: rgb(2, 54, 136);
  --nsw-blue-800: rgb(0, 38, 100);
  --nsw-blue-850: rgb(0, 26, 77);
  --nsw-blue-900: rgb(0, 16, 55);
  --nsw-blue-950: rgb(0, 6, 34);
  --nsw-purple-50: rgb(249, 247, 255);
  --nsw-purple-100: rgb(242, 240, 255);
  --nsw-purple-150: rgb(236, 232, 254);
  --nsw-purple-200: rgb(230, 225, 253);
  --nsw-purple-250: rgb(224, 217, 254);
  --nsw-purple-300: rgb(218, 208, 254);
  --nsw-purple-350: rgb(212, 200, 255);
  --nsw-purple-400: rgb(206, 191, 255);
  --nsw-purple-450: rgb(186, 166, 252);
  --nsw-purple-500: rgb(166, 141, 249);
  --nsw-purple-550: rgb(147, 114, 245);
  --nsw-purple-600: rgb(128, 85, 241);
  --nsw-purple-650: rgb(114, 67, 207);
  --nsw-purple-700: rgb(100, 50, 174);
  --nsw-purple-750: rgb(84, 33, 142);
  --nsw-purple-800: rgb(68, 17, 112);
  --nsw-purple-850: rgb(51, 8, 86);
  --nsw-purple-900: rgb(35, 2, 62);
  --nsw-purple-950: rgb(19, 0, 39);
  --nsw-fuchsia-50: rgb(255, 246, 253);
  --nsw-fuchsia-100: rgb(255, 238, 249);
  --nsw-fuchsia-150: rgb(254, 230, 246);
  --nsw-fuchsia-200: rgb(253, 222, 242);
  --nsw-fuchsia-250: rgb(251, 212, 239);
  --nsw-fuchsia-300: rgb(249, 201, 235);
  --nsw-fuchsia-350: rgb(247, 191, 233);
  --nsw-fuchsia-400: rgb(244, 181, 230);
  --nsw-fuchsia-450: rgb(239, 150, 218);
  --nsw-fuchsia-500: rgb(233, 117, 204);
  --nsw-fuchsia-550: rgb(225, 80, 190);
  --nsw-fuchsia-600: rgb(217, 18, 174);
  --nsw-fuchsia-650: rgb(187, 12, 148);
  --nsw-fuchsia-700: rgb(157, 6, 123);
  --nsw-fuchsia-750: rgb(129, 2, 100);
  --nsw-fuchsia-800: rgb(101, 0, 77);
  --nsw-fuchsia-850: rgb(77, 0, 58);
  --nsw-fuchsia-900: rgb(55, 0, 40);
  --nsw-fuchsia-950: rgb(34, 0, 23);
  --nsw-red-50: rgb(255, 248, 249);
  --nsw-red-100: rgb(255, 242, 244);
  --nsw-red-150: rgb(255, 236, 239);
  --nsw-red-200: rgb(255, 230, 234);
  --nsw-red-250: rgb(255, 219, 224);
  --nsw-red-300: rgb(255, 207, 214);
  --nsw-red-350: rgb(255, 196, 204);
  --nsw-red-400: rgb(255, 184, 193);
  --nsw-red-450: rgb(248, 151, 162);
  --nsw-red-500: rgb(239, 117, 129);
  --nsw-red-550: rgb(228, 79, 95);
  --nsw-red-600: rgb(215, 21, 58);
  --nsw-red-650: rgb(185, 14, 50);
  --nsw-red-700: rgb(155, 7, 42);
  --nsw-red-750: rgb(126, 3, 34);
  --nsw-red-800: rgb(99, 0, 25);
  --nsw-red-850: rgb(76, 0, 16);
  --nsw-red-900: rgb(54, 0, 8);
  --nsw-red-950: rgb(33, 0, 3);
  --nsw-orange-50: rgb(255, 250, 246);
  --nsw-orange-100: rgb(255, 246, 238);
  --nsw-orange-150: rgb(254, 241, 231);
  --nsw-orange-200: rgb(253, 237, 223);
  --nsw-orange-250: rgb(254, 229, 206);
  --nsw-orange-300: rgb(255, 221, 189);
  --nsw-orange-350: rgb(255, 214, 171);
  --nsw-orange-400: rgb(255, 206, 153);
  --nsw-orange-450: rgb(253, 182, 120);
  --nsw-orange-500: rgb(251, 157, 88);
  --nsw-orange-550: rgb(247, 129, 57);
  --nsw-orange-600: rgb(243, 99, 27);
  --nsw-orange-650: rgb(219, 81, 21);
  --nsw-orange-700: rgb(195, 63, 14);
  --nsw-orange-750: rgb(171, 46, 6);
  --nsw-orange-800: rgb(148, 27, 0);
  --nsw-orange-850: rgb(115, 15, 0);
  --nsw-orange-900: rgb(83, 4, 0);
  --nsw-orange-950: rgb(53, 0, 0);
  --nsw-yellow-50: rgb(255, 252, 240);
  --nsw-yellow-100: rgb(255, 250, 229);
  --nsw-yellow-150: rgb(255, 247, 218);
  --nsw-yellow-200: rgb(255, 244, 207);
  --nsw-yellow-250: rgb(255, 241, 194);
  --nsw-yellow-300: rgb(254, 238, 181);
  --nsw-yellow-350: rgb(254, 234, 168);
  --nsw-yellow-400: rgb(253, 231, 154);
  --nsw-yellow-450: rgb(251, 218, 128);
  --nsw-yellow-500: rgb(250, 205, 99);
  --nsw-yellow-550: rgb(250, 190, 66);
  --nsw-yellow-600: rgb(250, 175, 5);
  --nsw-yellow-650: rgb(212, 148, 3);
  --nsw-yellow-700: rgb(175, 122, 1);
  --nsw-yellow-750: rgb(139, 96, 0);
  --nsw-yellow-800: rgb(105, 72, 0);
  --nsw-yellow-850: rgb(80, 53, 0);
  --nsw-yellow-900: rgb(57, 36, 0);
  --nsw-yellow-950: rgb(34, 19, 0);
  --nsw-brown-50: rgb(251, 248, 244);
  --nsw-brown-100: rgb(246, 241, 234);
  --nsw-brown-150: rgb(242, 234, 225);
  --nsw-brown-200: rgb(237, 227, 215);
  --nsw-brown-250: rgb(236, 222, 206);
  --nsw-brown-300: rgb(234, 218, 198);
  --nsw-brown-350: rgb(233, 213, 189);
  --nsw-brown-400: rgb(232, 208, 181);
  --nsw-brown-450: rgb(219, 191, 159);
  --nsw-brown-500: rgb(207, 174, 137);
  --nsw-brown-550: rgb(194, 157, 115);
  --nsw-brown-600: rgb(182, 141, 93);
  --nsw-brown-650: rgb(156, 118, 75);
  --nsw-brown-700: rgb(130, 96, 58);
  --nsw-brown-750: rgb(106, 75, 41);
  --nsw-brown-800: rgb(82, 55, 25);
  --nsw-brown-850: rgb(62, 40, 15);
  --nsw-brown-900: rgb(43, 26, 7);
  --nsw-brown-950: rgb(25, 13, 2);
  --nsw-aboriginal-grey-50: rgb(249, 248, 247);
  --nsw-aboriginal-grey-100: rgb(242, 241, 239);
  --nsw-aboriginal-grey-150: rgb(235, 234, 232);
  --nsw-aboriginal-grey-200: rgb(229, 227, 224);
  --nsw-aboriginal-grey-250: rgb(223, 220, 216);
  --nsw-aboriginal-grey-300: rgb(216, 212, 209);
  --nsw-aboriginal-grey-350: rgb(210, 205, 201);
  --nsw-aboriginal-grey-400: rgb(204, 198, 194);
  --nsw-aboriginal-grey-450: rgb(173, 168, 165);
  --nsw-aboriginal-grey-500: rgb(142, 139, 138);
  --nsw-aboriginal-grey-550: rgb(113, 112, 111);
  --nsw-aboriginal-grey-600: rgb(85, 85, 85);
  --nsw-aboriginal-grey-650: rgb(73, 73, 73);
  --nsw-aboriginal-grey-700: rgb(61, 61, 61);
  --nsw-aboriginal-grey-750: rgb(50, 50, 50);
  --nsw-aboriginal-grey-800: rgb(39, 39, 39);
  --nsw-aboriginal-grey-850: rgb(28, 28, 28);
  --nsw-aboriginal-grey-900: rgb(17, 17, 17);
  --nsw-aboriginal-grey-950: rgb(7, 7, 7);
  --nsw-aboriginal-red-50: rgb(255, 245, 245);
  --nsw-aboriginal-red-100: rgb(255, 235, 235);
  --nsw-aboriginal-red-150: rgb(254, 226, 226);
  --nsw-aboriginal-red-200: rgb(253, 217, 217);
  --nsw-aboriginal-red-250: rgb(253, 208, 208);
  --nsw-aboriginal-red-300: rgb(252, 199, 198);
  --nsw-aboriginal-red-350: rgb(252, 189, 189);
  --nsw-aboriginal-red-400: rgb(251, 180, 179);
  --nsw-aboriginal-red-450: rgb(247, 150, 147);
  --nsw-aboriginal-red-500: rgb(242, 119, 113);
  --nsw-aboriginal-red-550: rgb(234, 85, 76);
  --nsw-aboriginal-red-600: rgb(225, 38, 28);
  --nsw-aboriginal-red-650: rgb(205, 31, 23);
  --nsw-aboriginal-red-700: rgb(186, 24, 17);
  --nsw-aboriginal-red-750: rgb(167, 17, 11);
  --nsw-aboriginal-red-800: rgb(149, 9, 6);
  --nsw-aboriginal-red-850: rgb(116, 0, 1);
  --nsw-aboriginal-red-900: rgb(84, 0, 0);
  --nsw-aboriginal-red-950: rgb(54, 0, 0);
  --nsw-aboriginal-orange-50: rgb(255, 244, 236);
  --nsw-aboriginal-orange-100: rgb(254, 233, 221);
  --nsw-aboriginal-orange-150: rgb(252, 223, 205);
  --nsw-aboriginal-orange-200: rgb(249, 212, 190);
  --nsw-aboriginal-orange-250: rgb(248, 202, 174);
  --nsw-aboriginal-orange-300: rgb(247, 191, 158);
  --nsw-aboriginal-orange-350: rgb(246, 181, 142);
  --nsw-aboriginal-orange-400: rgb(244, 170, 125);
  --nsw-aboriginal-orange-450: rgb(243, 154, 102);
  --nsw-aboriginal-orange-500: rgb(242, 137, 79);
  --nsw-aboriginal-orange-550: rgb(240, 119, 54);
  --nsw-aboriginal-orange-600: rgb(238, 99, 20);
  --nsw-aboriginal-orange-650: rgb(212, 83, 16);
  --nsw-aboriginal-orange-700: rgb(186, 68, 10);
  --nsw-aboriginal-orange-750: rgb(161, 53, 5);
  --nsw-aboriginal-orange-800: rgb(136, 38, 0);
  --nsw-aboriginal-orange-850: rgb(105, 25, 0);
  --nsw-aboriginal-orange-900: rgb(76, 13, 0);
  --nsw-aboriginal-orange-950: rgb(48, 3, 0);
  --nsw-aboriginal-brown-50: rgb(252, 241, 233);
  --nsw-aboriginal-brown-100: rgb(246, 227, 215);
  --nsw-aboriginal-brown-150: rgb(239, 213, 196);
  --nsw-aboriginal-brown-200: rgb(233, 200, 178);
  --nsw-aboriginal-brown-250: rgb(228, 186, 159);
  --nsw-aboriginal-brown-300: rgb(222, 173, 140);
  --nsw-aboriginal-brown-350: rgb(217, 159, 120);
  --nsw-aboriginal-brown-400: rgb(211, 145, 101);
  --nsw-aboriginal-brown-450: rgb(198, 129, 88);
  --nsw-aboriginal-brown-500: rgb(185, 114, 75);
  --nsw-aboriginal-brown-550: rgb(171, 98, 62);
  --nsw-aboriginal-brown-600: rgb(158, 83, 50);
  --nsw-aboriginal-brown-650: rgb(139, 70, 39);
  --nsw-aboriginal-brown-700: rgb(121, 57, 28);
  --nsw-aboriginal-brown-750: rgb(103, 45, 16);
  --nsw-aboriginal-brown-800: rgb(85, 33, 5);
  --nsw-aboriginal-brown-850: rgb(65, 22, 2);
  --nsw-aboriginal-brown-900: rgb(45, 12, 0);
  --nsw-aboriginal-brown-950: rgb(27, 4, 0);
  --nsw-aboriginal-yellow-50: rgb(255, 252, 238);
  --nsw-aboriginal-yellow-100: rgb(255, 248, 224);
  --nsw-aboriginal-yellow-150: rgb(255, 245, 211);
  --nsw-aboriginal-yellow-200: rgb(255, 241, 197);
  --nsw-aboriginal-yellow-250: rgb(255, 238, 183);
  --nsw-aboriginal-yellow-300: rgb(255, 235, 169);
  --nsw-aboriginal-yellow-350: rgb(254, 231, 155);
  --nsw-aboriginal-yellow-400: rgb(254, 228, 140);
  --nsw-aboriginal-yellow-450: rgb(254, 214, 117);
  --nsw-aboriginal-yellow-500: rgb(254, 200, 93);
  --nsw-aboriginal-yellow-550: rgb(254, 185, 68);
  --nsw-aboriginal-yellow-600: rgb(254, 169, 39);
  --nsw-aboriginal-yellow-650: rgb(223, 150, 28);
  --nsw-aboriginal-yellow-700: rgb(193, 131, 18);
  --nsw-aboriginal-yellow-750: rgb(165, 112, 7);
  --nsw-aboriginal-yellow-800: rgb(137, 94, 0);
  --nsw-aboriginal-yellow-850: rgb(105, 71, 0);
  --nsw-aboriginal-yellow-900: rgb(76, 48, 0);
  --nsw-aboriginal-yellow-950: rgb(47, 28, 0);
  --nsw-aboriginal-green-50: rgb(245, 249, 242);
  --nsw-aboriginal-green-100: rgb(236, 243, 231);
  --nsw-aboriginal-green-150: rgb(227, 236, 220);
  --nsw-aboriginal-green-200: rgb(218, 230, 209);
  --nsw-aboriginal-green-250: rgb(209, 224, 198);
  --nsw-aboriginal-green-300: rgb(199, 217, 186);
  --nsw-aboriginal-green-350: rgb(190, 211, 175);
  --nsw-aboriginal-green-400: rgb(181, 205, 164);
  --nsw-aboriginal-green-450: rgb(165, 194, 142);
  --nsw-aboriginal-green-500: rgb(149, 183, 119);
  --nsw-aboriginal-green-550: rgb(134, 172, 96);
  --nsw-aboriginal-green-600: rgb(120, 161, 70);
  --nsw-aboriginal-green-650: rgb(95, 143, 68);
  --nsw-aboriginal-green-700: rgb(73, 125, 64);
  --nsw-aboriginal-green-750: rgb(52, 106, 59);
  --nsw-aboriginal-green-800: rgb(33, 88, 52);
  --nsw-aboriginal-green-850: rgb(21, 66, 37);
  --nsw-aboriginal-green-900: rgb(10, 46, 23);
  --nsw-aboriginal-green-950: rgb(2, 27, 10);
  --nsw-aboriginal-blue-50: rgb(238, 248, 250);
  --nsw-aboriginal-blue-100: rgb(223, 241, 244);
  --nsw-aboriginal-blue-150: rgb(208, 233, 238);
  --nsw-aboriginal-blue-200: rgb(193, 226, 232);
  --nsw-aboriginal-blue-250: rgb(178, 219, 226);
  --nsw-aboriginal-blue-300: rgb(163, 212, 220);
  --nsw-aboriginal-blue-350: rgb(148, 204, 215);
  --nsw-aboriginal-blue-400: rgb(132, 197, 209);
  --nsw-aboriginal-blue-450: rgb(103, 174, 192);
  --nsw-aboriginal-blue-500: rgb(74, 150, 176);
  --nsw-aboriginal-blue-550: rgb(46, 127, 161);
  --nsw-aboriginal-blue-600: rgb(13, 103, 145);
  --nsw-aboriginal-blue-650: rgb(9, 93, 132);
  --nsw-aboriginal-blue-700: rgb(5, 83, 119);
  --nsw-aboriginal-blue-750: rgb(2, 73, 106);
  --nsw-aboriginal-blue-800: rgb(0, 64, 94);
  --nsw-aboriginal-blue-850: rgb(0, 47, 72);
  --nsw-aboriginal-blue-900: rgb(0, 32, 51);
  --nsw-aboriginal-blue-950: rgb(0, 17, 31);
  --nsw-aboriginal-purple-50: rgb(250, 241, 248);
  --nsw-aboriginal-purple-100: rgb(242, 229, 240);
  --nsw-aboriginal-purple-150: rgb(235, 216, 232);
  --nsw-aboriginal-purple-200: rgb(228, 204, 224);
  --nsw-aboriginal-purple-250: rgb(221, 191, 216);
  --nsw-aboriginal-purple-300: rgb(215, 179, 209);
  --nsw-aboriginal-purple-350: rgb(208, 166, 201);
  --nsw-aboriginal-purple-400: rgb(201, 154, 194);
  --nsw-aboriginal-purple-450: rgb(189, 139, 182);
  --nsw-aboriginal-purple-500: rgb(177, 124, 170);
  --nsw-aboriginal-purple-550: rgb(166, 109, 159);
  --nsw-aboriginal-purple-600: rgb(154, 94, 147);
  --nsw-aboriginal-purple-650: rgb(132, 79, 126);
  --nsw-aboriginal-purple-700: rgb(111, 65, 105);
  --nsw-aboriginal-purple-750: rgb(91, 51, 85);
  --nsw-aboriginal-purple-800: rgb(71, 38, 66);
  --nsw-aboriginal-purple-850: rgb(53, 26, 49);
  --nsw-aboriginal-purple-900: rgb(36, 16, 33);
  --nsw-aboriginal-purple-950: rgb(21, 6, 18);
  --success-50: rgb(239, 249, 237);
  --success-100: rgb(224, 243, 222);
  --success-150: rgb(210, 236, 207);
  --success-200: rgb(196, 229, 192);
  --success-250: rgb(170, 214, 165);
  --success-300: rgb(143, 199, 138);
  --success-350: rgb(116, 183, 111);
  --success-400: rgb(88, 168, 84);
  --success-450: rgb(73, 161, 70);
  --success-500: rgb(57, 153, 54);
  --success-550: rgb(37, 146, 36);
  --success-600: rgb(0, 138, 7);
  --success-650: rgb(0, 114, 4);
  --success-700: rgb(0, 90, 2);
  --success-750: rgb(0, 68, 1);
  --success-800: rgb(0, 47, 0);
  --success-850: rgb(0, 34, 0);
  --success-900: rgb(0, 22, 0);
  --success-950: rgb(0, 11, 0);
  --warning-50: rgb(255, 243, 237);
  --warning-100: rgb(255, 232, 222);
  --warning-150: rgb(255, 221, 207);
  --warning-200: rgb(253, 210, 192);
  --warning-250: rgb(246, 189, 165);
  --warning-300: rgb(238, 168, 138);
  --warning-350: rgb(230, 147, 111);
  --warning-400: rgb(221, 125, 83);
  --warning-450: rgb(216, 114, 68);
  --warning-500: rgb(211, 103, 52);
  --warning-550: rgb(206, 92, 33);
  --warning-600: rgb(201, 80, 0);
  --warning-650: rgb(168, 63, 3);
  --warning-700: rgb(136, 47, 3);
  --warning-750: rgb(105, 32, 1);
  --warning-800: rgb(75, 18, 0);
  --warning-850: rgb(57, 10, 0);
  --warning-900: rgb(39, 4, 0);
  --warning-950: rgb(23, 1, 0);
  --danger-50: rgb(255, 240, 239);
  --danger-100: rgb(255, 226, 225);
  --danger-150: rgb(255, 212, 212);
  --danger-200: rgb(253, 198, 198);
  --danger-250: rgb(244, 172, 173);
  --danger-300: rgb(234, 146, 148);
  --danger-350: rgb(223, 120, 124);
  --danger-400: rgb(211, 93, 101);
  --danger-450: rgb(205, 78, 89);
  --danger-500: rgb(198, 63, 78);
  --danger-550: rgb(191, 44, 66);
  --danger-600: rgb(184, 18, 55);
  --danger-650: rgb(153, 11, 42);
  --danger-700: rgb(124, 6, 31);
  --danger-750: rgb(95, 2, 20);
  --danger-800: rgb(68, 0, 10);
  --danger-850: rgb(51, 0, 5);
  --danger-900: rgb(35, 0, 2);
  --danger-950: rgb(20, 0, 1);
  --info-50: rgb(233, 238, 247);
  --info-100: rgb(212, 221, 235);
  --info-150: rgb(192, 204, 224);
  --info-200: rgb(172, 187, 213);
  --info-250: rgb(150, 169, 204);
  --info-300: rgb(128, 152, 194);
  --info-350: rgb(107, 134, 184);
  --info-400: rgb(87, 117, 174);
  --info-450: rgb(77, 108, 169);
  --info-500: rgb(66, 100, 164);
  --info-550: rgb(56, 91, 158);
  --info-600: rgb(46, 82, 153);
  --info-650: rgb(35, 66, 127);
  --info-700: rgb(25, 51, 102);
  --info-750: rgb(16, 37, 79);
  --info-800: rgb(7, 23, 56);
  --info-850: rgb(4, 15, 42);
  --info-900: rgb(2, 7, 28);
  --info-950: rgb(0, 3, 15);
  --white: rgb(255, 255, 255);
  --black: rgb(0, 0, 0);
}
